export default __webpack_public_path__ + "static/6.5 - 3-f9ffa79ee7baede19f60690b647491e6.png";